<template>
    <main class="app-content">
        <slot/>
    </main>
</template>

<script>
export default {
        name: "AppContent"
    }
</script>

<style>
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.app-content {
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  max-width: 100%;
  position: relative;
}

.app-header.fixed + .app-content, .app-header.fixed + div > .app-content {
  padding-top: 56px;
}

.app-header.fixed.has-toolbar + .app-content, .app-header.fixed.has-toolbar + div > .app-content {
  padding-top: 98px;
}
</style>